import React, { lazy, Suspense } from 'react'
import ReactDOM from 'react-dom'
import AuthDataProvider from "./components/../__providers/AuthProvider"
import { BrowserRouter as Router } from "react-router-dom"
import * as serviceWorker from './serviceWorker'

//
import { createStore, applyMiddleware } from 'redux'
import rootReducer from './__reducers/index'
import { Provider } from 'react-redux'
import thunk from 'redux-thunk'

// stripe
import { Elements as StripeElements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'

import { PKEY } from './__constants/Stripe'

const App = lazy(() => import('./App'))

const history = require("history").createLocation
const store = createStore(rootReducer, applyMiddleware(thunk))

const stripePromise = loadStripe(PKEY)

ReactDOM.render(
    <Router history={history}>
        <StripeElements stripe={stripePromise}>
            <AuthDataProvider>
                <Provider store={store}>
                    <Suspense fallback={<>.</>}>
                        <App />
                    </Suspense>
                </Provider>
            </AuthDataProvider>
        </StripeElements>
    </Router>,
    document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
